import { applyKeyframe } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css, keyframes } from 'styled-components';

const { colors } = themeVariables;

export const SIZE = 50;
const STROKE = 3;
export const RADIUS = (SIZE - STROKE) / 2;
export const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
export const CENTRE = SIZE / 2;

// The ring fills clockwise as time elapses: empty (full dash offset) at the start of a slide's
// dwell, complete (zero offset) just before it auto-advances.
const countdown = keyframes`
  from {
    stroke-dashoffset: ${CIRCUMFERENCE};
  }

  to {
    stroke-dashoffset: 0;
  }
`;

export const ring = css`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${SIZE}px;
  height: ${SIZE}px;
  /* Centre over the 44px IconButton and start the stroke at 12 o'clock. */
  transform: translate(-50%, -50%) rotate(-90deg);
  pointer-events: none;
`;

export const track = css`
  fill: none;
  stroke: var(${colors.stroke.default});
  stroke-width: ${STROKE};
  opacity: 0.3;
`;

export const progress = css`
  fill: none;
  stroke: var(${colors.stroke.default});
  stroke-width: ${STROKE};
  stroke-linecap: round;
  stroke-dasharray: ${CIRCUMFERENCE};
  animation-name: ${applyKeyframe(countdown)};
  animation-timing-function: linear;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;
